// =========================
// Tables & Grid Styles
// =========================

import { flexRow, flexRowJBetweenAStart, flexRowWrap } from "./flex";
import { spaces } from "./spacing";
import { colors } from "./colors";

// =========================
// Table styles
// =========================

export const cellTextStyle = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "120px",
};

// =========================
// Main table view
// =========================

export const mainBox = {
  width: "100%",
  padding: `${spaces[0]} ${spaces[1]}`,
  minWidth: 0,
};

export const topBarSx = {
  ...flexRow,
  justifyContent: "space-between",
  padding: spaces[1],
};

export const resumeBoxSx = {
  ...flexRow,
  gap: spaces[3],
  padding: spaces[1],
};

export const resumeBox2Sx = {
  ...flexRow,
  gap: spaces[1],
  padding: `${spaces[0]} ${spaces[1]}`,
};

// =========================
// Filter table styles
// =========================

export const filterContainerBox = {
  width: "100%",
  overflow: "hidden",
};

export const filterOuterRow = {
  ...flexRowJBetweenAStart,
  paddingLeft: spaces[2],
  paddingRight: spaces[2],
  paddingTop: spaces[1],
  paddingBottom: spaces[1],
};

export const filterMainStack = {
  ...flexRowWrap,
  alignItems: "center",
  gap: spaces[2.5], // 20px
};

export const reportButtonsBox = {
  ...flexRow,
  minWidth: "104px",
};

// =========================
// Grid helpers (reports)
// =========================

export const gridItemStretch = {
  minWidth: 0,
  display: "flex",
  alignItems: "stretch",
};

export const gridChartItem = {
  ...gridItemStretch,
  justifyContent: "center",
  height: "100%",
};

// =========================
// Table button box
// =========================

export const tableButtonBox = {
  ...flexRow,
  gap: spaces["0.5"],
};

// =========================
// Status chips
// =========================

export const statusChipDefault = {
  bgcolor: colors.statusNeutral,
  color: colors.textPrimary,
  fontWeight: 600,
};

export const statusChipSuccess = {
  bgcolor: colors.statusSuccess,
  color: colors.white,
  fontWeight: 600,
};

export const statusChipWarning = {
  bgcolor: colors.statusWarning,
  color: colors.white,
  fontWeight: 600,
};

export const statusChipError = {
  bgcolor: colors.statusError,
  color: colors.white,
  fontWeight: 600,
};

export const statusChipInfo = {
  bgcolor: colors.statusInfo,
  color: colors.white,
  fontWeight: 600,
};
